import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { formatErrorMessage } from './format-error-message';
import { ToastService } from '../../shared/services/toast.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const dialog = inject(MatDialog);
  const toastService = inject(ToastService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if ([401, 403].includes(error.status)) {
        // Skip auth errors that come from the refresh endpoint itself — handled by tokenRefreshInterceptor
        if (req.url.includes('/Auth/RefreshToken')) {
          return throwError(() => error);
        }

        dialog.closeAll();

        // Clear local state
        authService.clearLocalSession();

        const msg = error.error?.errors?.[0] || 'Session expired. Please log in again.';
        toastService.error(msg + '.', ' ', 5000);

        // Full page redirect — prevents Angular router from rendering the login
        // component inside the authenticated shell layout
        window.location.href = '/login';
      } else if (error.status === 404) {
        toastService.error('Resource not found.', '', 5000);
      } else if (error.status === 409) {
        toastService.error(error.error?.message || 'Device already exists or conflict occurred.', '', 5000);
      } else if (error.status >= 500) {
        let msg = 'Server error. Please try again later.';
        if (error.error?.message) msg = error.error.message;
        if (error.error?.errors?.length) msg += `\n${error.error.errors.join('\n')}`;
        toastService.error(msg, '', 8000);
      } else if (error.status === 400) {
        toastService.error(formatErrorMessage(error.error), '', 8000);
      } else {
        toastService.error('An error occurred. Please try again later.', '', 5000);
      }

      return throwError(() => error);
    })
  );
};
